const locales = {
  en: require('./locale-en.json'),
  ru: require('./locale-ru.json')
}

export default locales
